import type {GetVehicleApiResponse} from '@dms/api/vehicle';

/**
 * Extract a custom field value from the API customFields array
 *
 * @param customFields - Array of custom fields from API response
 * @param definitionId - The definition ID to search for
 * @returns The field value as string or null if not found
 *
 * @example
 * ```typescript
 * const hsn = getCustomFieldValue(vehicle.customFields, VehicleCustomFields.hsn.definitionId);
 * // Returns: "1234" or null
 * ```
 */
export const getCustomFieldValue = (
  customFields: GetVehicleApiResponse['customFields'],
  definitionId: string
): string | null => {
  const field = customFields?.find((field) => field.definitionId === definitionId);
  if (!field) {
    return null;
  }
  const raw = field.value?.value;
  return raw === null || raw === undefined ? null : String(raw);
};
